import axios from "axios";

// API Base URL
const BASE_URL = "https://wpbzijab2a.execute-api.us-east-1.amazonaws.com/dev";

/**
 * Updates a user in the database.
 * @param {string} bearerToken - The authorization token for the API call.
 * @param {object} user - The user object to update.
 * @returns {Promise<object>} - The response from the API.
 */
export const updatePaUser = async ({ bearerToken, user }) => {  
  try {
    const response = await axios.put(
      `${BASE_URL}/updatePaUser`,
      { user },  // The user object itself, without duplicate keys
      {
        headers: {
          Authorization: bearerToken,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating user:", error.response || error.message);
    throw error;
  }
};
